"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InversifyCoreErrorKind = void 0;
var InversifyCoreErrorKind;
(function (InversifyCoreErrorKind) {
    InversifyCoreErrorKind[InversifyCoreErrorKind["missingInjectionDecorator"] = 0] = "missingInjectionDecorator";
    InversifyCoreErrorKind[InversifyCoreErrorKind["unknown"] = 1] = "unknown";
})(InversifyCoreErrorKind || (exports.InversifyCoreErrorKind = InversifyCoreErrorKind = {}));
//# sourceMappingURL=InversifyCoreErrorKind.js.map